import { ISendMessageRequestSchema } from '../../repositories/cian-chat-bot/entities/send_message/SendMessageRequestSchema';
import {
  fetchPublicMobileV1SendMessage,
  TPublicMobileV1SendMessageResponse,
} from '../../repositories/cian-chat-bot/mobile/v1/send-message';
import { TContext } from '../../types/context';
import { mapChatbotMessageToChatMessage } from '../../utils/mapChatbotMessageToChatMessage';

export type { ISendMessageRequestSchema as TChatbotSendMessageParams };

export async function chatbotSendMessage({ httpApi, logger }: TContext, parameters: ISendMessageRequestSchema) {
  try {
    const { response, statusCode }: TPublicMobileV1SendMessageResponse = await fetchPublicMobileV1SendMessage({
      httpApi,
      parameters,
    });

    if (statusCode !== 200) {
      logger.warning('Код ответа не 200', {
        message: 'Не удалось отправить сообщение в чатбот',
        domain: 'src/shared/services/chatbotSendMessage/chatbotSendMessage.ts',
        statusCode,
        messsage: response.message || 'Неизвестная ошибка',
        errors: JSON.stringify(response?.errors),
      });

      return null;
    }

    return mapChatbotMessageToChatMessage(response.message);
  } catch (error) {
    logger.error(error, {
      domain: 'src/shared/services/chatbotSendMessage/chatbotSendMessage.ts',
      message: 'Не удалось отправить сообщение',
    });

    return null;
  }
}
